import React, { Component } from 'react'
import localization from '../localization/localization'
import './Openingtimes.css'
import Weekdays from './Weekdays'
import {weekdayData, weekdayData2, weekdayData3, weekdayData4, weekdayData5, weekdayData6, weekdayData7, weekdayData8, weekdayData9, weekdayData10} from './WeekdayData'

export default class Openingtimes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openingtimeBackground: process.env.PUBLIC_URL + '/media/verkkokauppa.jpg',
    }
  }

  render() {
    const weekDay = weekdayData(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay2 = weekdayData2(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay3 = weekdayData3(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay4 = weekdayData4(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay5 = weekdayData5(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay6 = weekdayData6(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay7 = weekdayData7(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay8 = weekdayData8(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay9 = weekdayData9(localization).map(item => <Weekdays key={item.id} item={item}/>)
    const weekDay10 = weekdayData10(localization).map(item => <Weekdays key={item.id} item={item}/>)

    return (
      <div className="openingtimes-body">
        <div className="openingtimes-background-img" style={{backgroundImage: `url(${this.state.openingtimeBackground})`}}></div>
          <div className="openingtimes-body-container">
            <div className="openingtimes-infobox">
              <h1>{localization.openingtimes7.title}</h1>
              <ul>
                <li>
                  {weekDay7}
                </li>
              </ul>
              <h1>{localization.openingtimes8.title}</h1>
              <ul>
                <li>
                  {weekDay8}
                </li>
              </ul>
              <h1>{localization.openingtimes9.title}</h1>
              <ul>
                <li>
                  {weekDay9}
                </li>
              </ul> 
              <h1>{localization.openingtimes10.title}</h1>
              <ul>
                <li>
                  {weekDay10}
                </li>
              </ul> 
            </div>
          </div>
      </div>
    );
  }
}